var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,105.3c-2.8,0-5.6-0.7-8.2-2.1c-5.7-3.1-9.1-8.7-9.1-15.2V55.1c0-6.5,3.4-12.2,9.1-15.2 c5.7-3.1,12.3-2.7,17.7,0.9l24.7,16.4c4.8,3.2,7.7,8.6,7.7,14.4s-2.9,11.2-7.7,14.4l-24.7,16.4C65.5,104.3,62.2,105.3,58.8,105.3z  M58.8,41.8c-2.1,0-4.3,0.5-6.3,1.6c-4.4,2.3-7,6.7-7,11.7V88c0,5,2.6,9.3,7,11.7c4.4,2.3,9.5,2.1,13.6-0.7l24.7-16.4l1.1,1.7 l-1.1-1.7c3.8-2.5,5.9-6.5,5.9-11s-2.2-8.5-5.9-11L66.2,44C63.9,42.5,61.4,41.8,58.8,41.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.fce8aa4cc2629ce9a2688b5ca7031997.svg";
export { ForwardRef as ReactComponent };